export const PRICE_LIST_TYPE_ENUM = {
  default: "default",
  promo: "promo",
};
